module.exports = __webpack_public_path__ + "static/media/31JFA8.1a4ee6ec.jpg";